/*
 * @description: 用车原由
 */
import { useState, useCallback } from 'react';

type SetDataType = {
  orderReason: string;
  orderReasonTag: string[];
};

export default function OrderCenterSameCityUseCarReason() {
  // 用车原由下拉选择
  const [orderReasonTag, setOrderReasonTag] = useState<string[]>([]);
  const setOrderReasonTagM = useCallback((val) => {
    setOrderReasonTag(val);
  }, []);

  // 用车原由输入框
  const [orderReason, setOrderReason] = useState('');
  const setOrderReasonM = useCallback((val) => {
    setOrderReason(val);
  }, []);

  // 更新所有数据
  const set = useCallback((val: SetDataType) => {
    setOrderReasonTag(val.orderReasonTag);
    setOrderReason(val.orderReason);
  }, []);

  //  清空数据
  const reset = useCallback(() => {
    setOrderReason('');
    setOrderReasonTag([]);
  }, []);

  return {
    orderReasonTag,
    setOrderReasonTagM,
    orderReason,
    setOrderReasonM,
    set,
    reset,
  };
}
